import { CommonModule } from '@angular/common';
import { FileuploadComponent } from './fileupload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { DndModule } from 'ngx-drag-drop';
import { NgModule } from '@angular/core';
import { UploadIsRequired } from './upload-required.directive';
import { TranslateModule } from '@ngx-translate/core';
import {TranslateDesignPipe} from '../../pipes/translate-design/translate-design.pipe';

@NgModule({
   declarations: [
      FileuploadComponent,
      UploadIsRequired,
      TranslateDesignPipe
   ],
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      DndModule,
      TranslateModule
   ],
   exports: [
      FileuploadComponent,
      UploadIsRequired,
      MaterialModule,
      TranslateDesignPipe
   ],
   providers: [
      TranslateDesignPipe
   ]
})
export class FileuploadModule { }
